var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"component":_vm.$options.name}},[_c('v-container',{staticClass:"py-0 px-4",staticStyle:{"max-width":"800px"}},[(_vm.event)?_c('app-events-event-details',{attrs:{"event":_vm.event,"breadcrumbs":_vm.breadcrumbs}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }